import { eachDayOfInterval, endOfMonth, getMonth } from 'date-fns';

export const getAllLastDaysInMonth = (date: Date) => {
    const lastDate = endOfMonth(date); // Get the last day of the month
    const allDays = eachDayOfInterval({ start: lastDate, end: lastDate });
    return Array.from(new Set(allDays.map((d) => getMonth(d).toString())));
};

export const areArraysEqual = (arr1: string[], arr2: string[]) => {
    if (arr1.length !== arr2.length) return false;
    return arr1.every((value, index) => value === arr2[index]);
};

export const paramsToString = (params: URLSearchParams) =>
    `?${params.toString().replace(/%2C/g, ',')}`;
